interface AddressLabels {
    street: string;
    number: string;
    complement: string;
    neighborhood: string;
    city: string;
    state: string;
    postalCode: string;
}

interface Country {
    code: string;
    name: string;
    flag: string;
    phoneFormat: string;
    phoneDDI: string;
    addressLabels: AddressLabels;
    postalCodeMask: string;
    postalCodeRegex: string;
    hasAddressLookup: boolean;
    numberBeforeStreet: boolean;
    uses12HourFormat: boolean;
}

export const countries: Country[] = [
    { 
        code: 'BR', 
        name: 'Brazil', 
        flag: '🇧🇷 ',
        phoneFormat: '(99) 99999-9999',
        phoneDDI: '+55',
        addressLabels: {
            street: 'Street/Avenue',
            number: 'Number',
            complement: 'Complement',
            neighborhood: 'District',
            city: 'City',
            state: 'State',
            postalCode: 'Postal Code'
        },
        postalCodeMask: '99999-999',
        postalCodeRegex: '^\\d{5}-?\\d{3}$',
        hasAddressLookup: true,
        numberBeforeStreet: false,
        uses12HourFormat: false
    },
    { 
        code: 'US', 
        name: 'United States', 
        flag: '🇺🇸 ',
        phoneFormat: '(999) 999-9999',
        phoneDDI: '+1',
        addressLabels: {
            street: 'Street',
            number: 'Number',
            complement: 'Apt/Suite',
            neighborhood: 'District',
            city: 'City',
            state: 'State',
            postalCode: 'ZIP Code'
        },
        postalCodeMask: '99999',
        postalCodeRegex: '^\\d{5}$',
        hasAddressLookup: false,
        numberBeforeStreet: false,
        uses12HourFormat: false
    },
    { 
        code: 'GB', 
        name: 'United Kingdom', 
        flag: '🇬🇧 ',
        phoneFormat: '99999 999999',
        phoneDDI: '+44',
        addressLabels: {
            street: 'Street',
            number: 'Number',
            complement: 'Second Line of the Address',
            neighborhood: 'District',
            city: 'City',
            state: 'County',
            postalCode: 'Postcode'
        },
        postalCodeMask: 'AA9A 9AA',
        postalCodeRegex: '^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$',
        hasAddressLookup: true,
        numberBeforeStreet: true,
        uses12HourFormat: false
    }
];

export const getCountryByCode = (code: string): Country | undefined => {
    return countries.find(country => country.code === code);
};

export const getCountryFlag = (code: string): string => {
    return getCountryByCode(code)?.flag ?? '';
}; 